import { Platform } from 'react-native';
import notifee from '@notifee/react-native';
import { v2GetUnreadCounts } from './v2/api';

class BadgeManager {
    private currentBadgeCount: number = 0;

    /**
     * Set the app icon badge count
     */
    public async setBadge(count: number): Promise<void> {
        this.currentBadgeCount = count;

        try {
            if (Platform.OS === 'ios') {
                // iOS: Use notifee to set badge
                await notifee.setBadgeCount(count);
            } else {
                // Android: Use notifee for badge (works on most launchers)
                await notifee.setBadgeCount(count);
            }
            console.log(`Badge count set to: ${count}`);
        } catch (error) {
            console.error('Failed to set badge count:', error);
        }
    }

    /**
     * Clear the app icon badge
     */
    public async clearBadge(): Promise<void> {
        await this.setBadge(0);
    }

    /**
     * Get the current badge count
     */
    public getBadgeCount(): number {
        return this.currentBadgeCount;
    }

    /**
     * Increment the badge count by a specified amount
     */
    public async incrementBadge(amount: number = 1): Promise<void> {
        await this.setBadge(this.currentBadgeCount + amount);
    }

    /**
     * Decrement the badge count by a specified amount
     */
    public async decrementBadge(amount: number = 1): Promise<void> {
        const newCount = Math.max(0, this.currentBadgeCount - amount);
        await this.setBadge(newCount);
    }

    /**
     * Refresh badge count from the backend
     * Fetches unread counts and updates the badge accordingly
     */
    public async refreshFromBackend(): Promise<void> {
        try {
            const counts = await v2GetUnreadCounts();
            await this.setBadge(counts.total);
        } catch (error) {
            console.error('Failed to refresh badge from backend:', error);
        }
    }
}

export const badgeManager = new BadgeManager();

